import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import React from "react";


const useStyles = makeStyles(theme => ({
	root: {
		marginTop: theme.spacing(3),
		marginBottom: theme.spacing(6)
	}
}));

/**
 * Represents the top content of a Page. Used to compose the layout of pages.
 *
 * @param {*} props
 * @returns
 */
export default function PageSectionHeader(props) {
	const { name, description, primaryActions, secondaryActions } = props;
	const classes = useStyles();

	return (
		<div id={"page-section-header"} className={classes.root}>
			<Grid
				container
				direction="row"
				justify="space-between"
				spacing={2}
				alignItems="flex-start"
			>
				<Grid item>
					<Typography component="h1" variant="h4">
						{name}
					</Typography>
					<Typography component="p" variant="subtitle1">
						{description}
					</Typography>
				</Grid>
				<Grid
					container
					item
					justify="space-between"
					alignItems="center"
					direction="row">
					{primaryActions &&
						<Grid
							item
							id="header-create-folder-wrapper"
						>
							{primaryActions()}
						</Grid>}
					{secondaryActions &&
						<Grid
							item
							id="header-folder-actions-wrapper"
						>
							{secondaryActions()}
						</Grid>}
				</Grid>
			</Grid>
		</div>
	);
}

PageSectionHeader.propTypes = {
	name: PropTypes.string,
	description: PropTypes.string,
	primaryActions: PropTypes.func,
	secondaryActions: PropTypes.func
};
